import { SignedOut, SignIn, useUser } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";
import { PAGES } from "../constants/pages";

const LoginPage = () => {
  const { isSignedIn } = useUser();

  if (isSignedIn) {
    return <Navigate to={PAGES.DASHBOARD} />;
  }

  return (
    <SignedOut>
      <div className="h-screen w-screen flex justify-center items-center">
        <SignIn />
      </div>
    </SignedOut>
  );
};

export default LoginPage;
